var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins } from 'vue-property-decorator';
import CrudSidesheetMixin from '@/mixins/crud-sidesheet-mixin';
import BaseCrudSidesheet from '@/components/base/BaseCrudSidesheet.vue';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
import UtilsMixin from '@/mixins/utils-mixin';
var BolFormatsCrudSidesheet = /** @class */ (function (_super) {
    __extends(BolFormatsCrudSidesheet, _super);
    function BolFormatsCrudSidesheet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BolFormatsCrudSidesheet.prototype.creating = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vendorBolFormat, vendor, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        vendorBolFormat = __assign({}, this.selectedItem);
                        vendor = __assign({}, this.item);
                        vendorBolFormat.vendorBolFormatId = this.getUniqueId();
                        return [4 /*yield*/, this.updating(vendorBolFormat)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to save allocation period',
                            color: 'error',
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.sidesheetLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BolFormatsCrudSidesheet.prototype.updating = function (item) {
        if (item === void 0) { item = null; }
        return __awaiter(this, void 0, void 0, function () {
            var vendor;
            return __generator(this, function (_a) {
                try {
                    if (item === null) {
                        item = __assign({}, this.selectedItem);
                    }
                    vendor = __assign({}, this.item);
                    // locally update collection
                    vendor.vendorBolFormats = this.updateItemsCollection(vendor.vendorBolFormats, item, ['vendorBolFormatId', 'vendorId']);
                    // update item we are looking at
                    this.item = vendor;
                    // close the side sheet
                    this.close();
                    this.showSnackbar({
                        text: 'Vendor BOL format has been saved locally.<br />You must SUBMIT the vendor in order for your changes to take affect.',
                        color: 'success',
                    });
                }
                catch (error) {
                    console.error(error);
                    this.showSnackbar({
                        text: 'Unable to save bol format',
                        color: 'error',
                    });
                }
                finally {
                    this.sidesheetLoading = false;
                }
                return [2 /*return*/];
            });
        });
    };
    BolFormatsCrudSidesheet.prototype.getUniqueId = function () {
        // this is about a one in a million chance of getting a duplicate. I'll take my chances
        return Math.floor(Math.random() * Math.floor(1000000)).toString();
    };
    BolFormatsCrudSidesheet = __decorate([
        Component({ components: { 'base-crud-sidesheet': BaseCrudSidesheet } })
    ], BolFormatsCrudSidesheet);
    return BolFormatsCrudSidesheet;
}(Mixins(CrudSidesheetMixin, SteppedPageMixin, SnackbarMixin, UtilsMixin)));
export default BolFormatsCrudSidesheet;
